<template>
<section class="dashboard-container rounded-4 p-4">
    <header class="dashboard-header bg-white p-3 mb-2 rounded-top-4 border">
      <h1 class=" text-center my-2">لوحة التحكم</h1>
      <hr>
      <div class="d-flex justify-content-between align-items-center mt-2">  
        <router-link v-if="getUser?.privs.includes('reports') " class="nav-link"  active-class="active" :to="{name: 'GeneralStats'}"> الإحصائيات </router-link>
        <router-link v-if="getUser?.privs.includes('addPrivilege') || getUser?.privs.includes('editGroup') || getUser?.privs.includes('suspendUser') || getUser?.privs.includes('userActivities')" class="nav-link"  active-class="active" :to="{name: 'Privileges'}"> المستخدمون </router-link>
        <router-link v-if="getUser?.privs.includes('addUser') " class="nav-link"  active-class="active" :to="{name: 'UserRegister'}"> تسجيل مستخدم جديد </router-link>
        <router-link class="nav-link"  active-class="active" :to="{name: 'settings'}"> إعدادات عامة </router-link>
      </div>
    </header>
   
    <router-view></router-view>
  </section>
</template>

<script>
import GeneralStats from "@/components/Dashboard/GeneralStats.vue";
import Privileges from "@/components/Dashboard/Privileges.vue";
import UserRegister from "@/components/Dashboard/UserRegister.vue";
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      stats: [],
      departs: [],
      vehicles: [], // List of vehicles
      filteredVehicles: [], // Filtered list for search
      searchQuery: "", // Search box input
    };
  },
  computed:{
    ...mapGetters(['getDeparts', 'getUser'])
  },
  created(){
    // this.fetchOptions()
    // this.fetchAllStats()
  },
  methods: {
    /** */
    ...mapActions([
      'fetchDeparts',
    ]),
    /********************************/
    // async fetchOptions() {
    //   if (this.getDeparts.length == 0) {
    //     await this.fetchDeparts(); // Fetch and store in Vuex
    //   }
    //   this.departs = this.getDeparts
    // },
    
    /********************************/
    /** */
    // async fetchAllStats() {
    //   try {
    //     const summeryResponse = await this.$axios.get("api/employee/report/statssummary")

    //     if (summeryResponse?.data.isSuccess) {
    //       const summeryData = summeryResponse.data.data;

    //       this.stats = summeryData
    //       console.log("", this.stats)
    //     }else{
    //       this.$tempAlert(summeryResponse?.data.msg,'warning');
    //     }
    //   } catch (error) {
    //     if(error.summeryResponse?.data){
    //         this.$tempAlert(error.summeryResponse?.data.msg,'warning');
    //       }
    //     console.error("Error fetching privileges and groups:", error);
    //   }
    // },
    /******************************/
  },
  components: {
    Privileges,
    UserRegister,
    GeneralStats
  }
};
</script>

<style scoped>
.dashboard-container {
  background-color: #f8f9fa;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.dashboard-header {
  height: 20vh;
  width: calc(100% + 3rem + var(--bs-border-width));
  position: relative;
  top: -1.5rem;
  right: calc(-1.5rem - var(--bs-border-width));

}
.card {
  border-radius: 15px;
}

.table {
  margin: 0;
}

.table th {
  text-align: center;
}

.table td {
  vertical-align: middle;
}

.badge {
  font-size: 0.9rem;
}

.btn {
  font-size: 0.85rem;
}
</style>